import { render, staticRenderFns } from "./Adminmenu.vue?vue&type=template&id=0866ec9b"
import script from "./Adminmenu.vue?vue&type=script&lang=js"
export * from "./Adminmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports